import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { BackButton } from "./BackNavigator.styles";

type BackNavigatorProps = {
  className?: string;
  title?: string;
};

export const BackNavigator = ({ className, title }: BackNavigatorProps) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <BackButton
      onClick={() => navigate(-1)}
      className={className}
      $isRTL={i18n.language === "ar"}
    >
      <IoArrowBack size={20} />
      <span>{title || t("back")}</span>
    </BackButton>
  );
}; 